module.exports = __webpack_public_path__ + "img/logo.bc10b446.png";